export default {
  tryNow: "今すぐ試す",
  retry: "再試行",
  back: "ホームに戻る",
  backToList: "記事一覧に戻る",
  read: "詳しく読む",
  readMore: "詳しく読む →",
  filter: "カテゴリーで絞り込み",
  all: "すべての記事",
  articles: "件の記事",
  noData: "記事がありません",
  tryDifferentFilter: "別のカテゴリーを選択してください",
  loading: "読み込み中...",
  notFound: "記事が見つかりません",
  articleNotFound: "お探しの記事は存在しないか、削除されています",
  previous: "前へ",
  next: "次へ",
  previousArticle: "前の記事",
  nextArticle: "次の記事",
  relatedArticles: "関連記事",
  topicNotFound: "トピックが見つかりません",
  topicNotFoundDescription: "お探しのトピックは存在しません。",
  noArticles: "まだ記事がありません",
  noArticlesDescription: "このカテゴリーにはまだ記事がありません。",
  explore: "探索",
  allArticles: "すべての記事",
  browseBlog: "ブログを見る",
  categories: "カテゴリー",
  popularTags: "人気タグ",
  showAllTags: "すべてのタグを表示",
  showFewerTags: "タグを折りたたむ",
};
